import { apiRequest } from "../util/apiUtils";

export const communicationList = async (params) => {
  try {
    const res = await apiRequest("get", `/communication-group/list`, {
      queries: params,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const communicationChatList = async (params) => {
  try {
    const res = await apiRequest("get", `/communication/chat-list`, {
      queries: params,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};
export const CreateChat = async (payload) => {
  try {
    const res = await apiRequest(
      "post",
      `communication/create-chat`,
      {
        body: payload,
      },
      "multipart/form-data",
    );

    return res?.data;
  } catch (err) {
    return err;
  }
};

export const communicationDelete = async (payload) => {
  try {
    const res = await apiRequest("delete", `communication/delete`, {
      body: payload,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const communicationStatusChange = async (payload) => {
  try {
    const res = await apiRequest("patch", `communication/status`, {
      body: payload,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const notificationList = async (params) => {
  try {
    const res = await apiRequest("get", `notification/backend/list`, {
      queries: params,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};
export const backendSeen = async (payload) => {
  try {
    const res = await apiRequest("post", `notification/backend/seen`, {
      body: payload,
    });

    return res?.data;
  } catch (err) {
    return err;
  }
};
